import { render, staticRenderFns } from "./date-panel-label.vue?vue&type=template&id=e5f2fcb2&"
import script from "./date-panel-label.vue?vue&type=script&lang=js&"
export * from "./date-panel-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports